import { render, staticRenderFns } from "./DenyRequest.vue?vue&type=template&id=1571de8c"
import script from "./DenyRequest.vue?vue&type=script&lang=js"
export * from "./DenyRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports